import { Component, OnInit } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {encodingClothsImages} from '../cloths-mockup';

@Component({
  selector: 'app-defect-encoding',
  templateUrl: './defect-encoding.component.html',
  styleUrls: ['./defect-encoding.component.css']
})
export class DefectEncodingComponent extends GeneralExerciseComponent {

  counter = 0;
  level = 1;
  encoding: number[][] = [];
  defectedEncoding: number[] = [];
  symbolImages = ['./assets/images/encodings/square.png', './assets/images/encodings/circle.png'];
  halfSymbolImages = ['./assets/images/encodings/half_square.png', './assets/images/encodings/half_circle.png',
                      './assets/images/encodings/both.png'];
  clothsImages = encodingClothsImages;
  solutionImageIdx = -1;
  solution: number[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
    this.encoding = [];
    this.defectedEncoding = [];
    this.solutionImageIdx = -1;
    this.solution = [];
  }

  checkSolution() {
    const tempIdx = this.getSolutionIdx();
    const idx1 = tempIdx[0];
    const idx2 = tempIdx[1];

    if (idx1 !== -1 && idx2 !== -1) {
      if (this.solution[this.solution.length - 1] !== idx1 && this.solution[this.solution.length - 1] !== idx2) {
        this.solution.pop();
      }

      for (let i = 0; i < this.solution.length; i++) {
        if (this.solution[i] === idx1) {
          this.solutionImageIdx = 0;
        }
        if (this.solution[i] === idx2) {
          this.solutionImageIdx = 1;
        }
      }

      if (this.solution.length === 2) {
        this.solutionImageIdx = 2;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      } else if (this.solution.length === 0) {
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      }
    } else {
      if (idx1 !== -1 && this.solution[0] === idx1) {
        this.solutionImageIdx = 0;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      } else if (idx2 !== -1 && this.solution[0] === idx2) {
        this.solutionImageIdx = 1;
        this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
        this.isSolvedImageVisible = true;
        this.solved = true;
        setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
        this.saveState();
      } else {
        this.solution.pop();
        this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      }
    }
  }

  generateNextExercise() {
    this.initValues();
    this.counter ++;
  }

  setTypeSpecificsFromConfiguration() {
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  computeState() {
    this.state.counter = this.counter;
  }

  setEncoding(encoding: number[][]) {
    this.encoding = encoding;

    if (this.defectedEncoding.length === 0) {
      const randIdx = Math.floor(Math.random() * encoding.length);
      this.defectedEncoding = Object.assign([], encoding[randIdx]);
      const defectIdx = Math.floor(Math.random() * this.defectedEncoding.length);
      this.defectedEncoding[defectIdx] = -1;
    }
  }

  setDefectEncoding(defectEncoding: number[]) {
    this.defectedEncoding = defectEncoding;
  }

  setSolution(idx: number) {
    if (this.solution.indexOf(idx) === -1) {
      this.solution.push(idx);
      this.checkSolution();
    }
  }

  getSymbolImage(idx: number) {
   if (idx === -1 && this.solved === false) {
      if (this.solutionImageIdx !== -1) {
        return this.halfSymbolImages[this.solutionImageIdx];
      } else {
        return './assets/images/encodings/openQuestion.png';
      }
    }

    if (idx === -1 && this.solved === true) {
      if (this.solutionImageIdx === 2) {
        return this.halfSymbolImages[2];
      } else {
        return this.symbolImages[this.solutionImageIdx];
      }
    }
    return this.symbolImages[idx];
  }

  getClothsImage(idx: number) {
    return this.clothsImages[idx];
  }

  getCodeWidth() {
    const width = 100 / this.defectedEncoding.length;
    return width.toString() + '%';
  }

  getSolutionIdx() {
    const temp1 = [];
    const temp2 = [];
    for (let i = 0; i < this.defectedEncoding.length; i++) {
      if (this.defectedEncoding[i] !== -1) {
        temp1[i] = this.defectedEncoding[i];
        temp2[i] = this.defectedEncoding[i];
      } else {
        temp1[i] = 0;
        temp2[i] = 1;
      }
    }

    const idx1 = this.encoding.findIndex(i => this.compareArrays(i, temp1));
    const idx2 = this.encoding.findIndex(i => this.compareArrays(i, temp2));

    return [idx1, idx2];
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  setLevel(level: number) {
    this.level = level;
  }
}
